import React from 'react';
import ValidationAddRuleSection from '../../../sections/AdminDashboard/Configuration/ValidationAddRule';

const ValidationAddRule = () => {
  return <ValidationAddRuleSection />;
};

export default ValidationAddRule;
